export const isMasterCard = (card) => card?.name?.includes('MASTER')
